import { bool } from './utils'

const STORAGE_KEYS = {
  SIDE_NAV_EXPANDED: 'sideNavExpanded',
  ERT_DEBUG_MODE: 'ertDebugMode'
}

export const getSideNavExpanded = (): boolean => {
  const value = localStorage.getItem(STORAGE_KEYS.SIDE_NAV_EXPANDED)
  return value ? JSON.parse(value) : true // Default to true if not set
}

export const setSideNavExpanded = (expanded: boolean): void => {
  localStorage.setItem(STORAGE_KEYS.SIDE_NAV_EXPANDED, JSON.stringify(expanded))
}

// this flag enables extra logging in the ERT player. It is intended for use by developers. It must be manually enabled in local storage by setting the key 'ertDebugMode' to 'true' in the browser's developer console.
export const isErtDebugMode = (): boolean => {
  const value = localStorage.getItem(STORAGE_KEYS.ERT_DEBUG_MODE)

  return bool(import.meta.env.VITE_ENABLE_ERT_DEBUG_MODE) || (value ? JSON.parse(value) : false) // Default to false if not set
}
